import { render, staticRenderFns } from "./AliPlayer.vue?vue&type=template&id=7c0679cc&scoped=true"
import script from "./AliPlayer.vue?vue&type=script&lang=js"
export * from "./AliPlayer.vue?vue&type=script&lang=js"
import style0 from "./AliPlayer.vue?vue&type=style&index=0&id=7c0679cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0679cc",
  null
  
)

export default component.exports